export class LocaleService {

  static locale(){
    let cultureNumber:string = CultureNameNumber.srCyrl.toString();
    if (localStorage.getItem('esourcing-translation-culture-number') != null) {
      cultureNumber = localStorage.getItem('esourcing-translation-culture-number').toString();
    }
    return cultureNumber;
  }

}


export enum CultureNameNumber {
  srCyrl = 'sr-Cyrl',
}

